// extracted by mini-css-extract-plugin
export default {"container":"TnmwTopupModal_container__Cb8KD","header":"TnmwTopupModal_header__R3u3f","header-item":"TnmwTopupModal_header-item__f3tvF","active":"TnmwTopupModal_active__loqJk"};